import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Translator from 'translator';
import { Logger } from 'data/common';
import api from './api';
/** @var ApiCall apiCaller */
const apiCaller = getApiInstance();

function getNotifications() {
    return dispatch => {
        return apiCaller
            .call(api.getAllNotifications())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__INIT_NOTIFICATIONS',
                        notifications: data.notifications
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getFheNotifications - ', error);
                throw 'general.error.data_has_not_correctly_returned_by_server';
            });
    };
}

function getNotificationDetails(notificationId) {
    return dispatch => {
        return apiCaller
            .call(api.getNotificationDetails(notificationId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__SET_NOTIFICATIONDETAILS',
                        notification: data.notificationDetails
                    });
                    return data;
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
            })
            .catch(error => {
                Logger.log('dataActions: setFHENotificationDetails - ', error);
                throw error;
            });
    };
}

function getDefaultNotificationsButtons() {
    return dispatch => {
        return apiCaller
            .call(api.getNotificationsButtons())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__SET_DEFAULT_NOTIFICATIONS_BUTTONS',
                        buttons: data.buttons
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheNotificationsButtons - ', error);
                throw 'general.error.data_has_not_correctly_returned_by_server';
            });
    };
}

function updateNotificationDetails(notificationId, form) {
    return dispatch => {
        return apiCaller
            .call(api.updateNotificationDetails(notificationId, form))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__SET_NOTIFICATIONDETAILS',
                        notification: data.notificationDetails
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateFHENotificationDetails - ', error);
                throw error;
            });
    };
}

function addNotification(form) {
    return dispatch => {
        return apiCaller
            .call(api.addNotification(form))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__ADD_NOTIFICATION',
                        notification: data.notificationDetails,
                        notificationId: data.notificationId
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addFHENotification - ', error);
                throw error;
            });
    };
}

export { getNotifications, getNotificationDetails, getDefaultNotificationsButtons, updateNotificationDetails, addNotification };



// WEBPACK FOOTER //
// ./environments/fhe/data/Notifications/actions.js